import {SearchModel} from '../interfaces';

export function getDefaultSearchModel(): SearchModel {
    return {analogs: [], searched: [], original: []};
}
